import React, { Component } from 'react'
import Link from '../../utils/link'
import Sold from '../../assets/images/sold.svg'
import { Play, Bed, Bath, Car, Land, Build } from '../icons'

class PropertyFeature extends Component {

  state = {
    bed: `Bed`,
    bath: `Bath`,
    car: `Car`,
    view: `View`,
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if(window.innerWidth < 900) {
      this.setState({ 
        view: `View`,
      });
    } else {
      this.setState({ 
        view: `View Listing`,
      });
    }
  }

  render() {
    const { slug, title, databaseId, propertyAddress, propertyImages, propertyData, propertyListing, propertyLand, feature, postType, singleTemplate, video, onClick, propertyType } = this.props
    const sold = propertyListing?.marketingStatus === 'Sold'
    let { bed, bath, car, view } = this.state

    let pathName = `/${postType}/${slug}/`
    let heading = `${propertyAddress.streetAddress}<br />${propertyAddress.suburb} ${propertyAddress.postcode}`
    if (propertyAddress.hideAddress) {
      heading = propertyAddress.suburb
      pathName = `/${postType}/${propertyAddress.suburb.toLowerCase().replace(/ /gi, '-')}-${databaseId}/`
    }

    return (
      <div className={`property-feature ${sold ? 'property-feature--sold' : ''} ${feature ? 'property-feature--feature' : ''}`}>
        { feature && <img className='property-feature__bg' src={propertyImages?.length > 0 && propertyImages[0].large} alt={title} /> }
        <div className='property-feature__inner'>
          <div className='property-feature__details'>
            <span className='property-feature__tag'>{ propertyData.category }</span>
            { singleTemplate && <h1 dangerouslySetInnerHTML={{ __html: heading }} /> }
            { !singleTemplate && <h4 dangerouslySetInnerHTML={{ __html: heading }} /> }
            <div className='property-feature__specs property-feature__specs--desktop'>
              <span>{propertyListing?.displayPrice}</span>
              <ul>
                { propertyData.type !== 'Commercial' &&
                  <ul>
                    { propertyData?.bedrooms > 0 && <li><Bed color={`#FFFFFF`} /> {propertyData?.bedrooms}</li> }
                    { propertyData?.bathrooms > 0 && <li><Bath color={`#FFFFFF`} /> {propertyData?.bathrooms}</li> }
                    { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
                    { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}{propertyLand.landArea_unit === 'sqm' ? '㎡' : ' '+propertyLand.landArea_unit+'s'}</li> }
                  </ul>
                }
                { propertyData.type === 'Commercial' &&
                  <ul>
                    { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
                    { propertyLand?.buildingArea_value && <li className='area'><Build color={`#FFFFFF`} /> {propertyLand.buildingArea_value}{propertyLand.buildingArea_unit === 'sqm' ? '㎡' : ' '+propertyLand.buildingArea_unit+'s'}</li> }
                    { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}{propertyLand.landArea_unit === 'sqm' ? '㎡' : ' '+propertyLand.landArea_unit+'s'}</li> }
                  </ul>
                }
              </ul>
            </div>
          </div>
          { !singleTemplate && 
            <span className='property-feature__view'>{view}</span>
          }
          { video &&
            <span className='property-feature__view property-feature__play-video' onClick={onClick}>
              <Play color={'#FFFFFF'} />
              Play Video
            </span>
          }
        </div>
        <div className='property-feature__image'>
          <img src={propertyImages?.length > 0 && propertyImages[0].large} alt={title} />
          { sold && <img className='sold' src={Sold} alt='Sold' /> }
          { !singleTemplate && 
            <Link className='property-feature__link' to={pathName}></Link> 
          }
        </div>
        <div className='property-feature__specs property-feature__specs--mobile'>
          <span>{propertyListing?.displayPrice}</span>
          { propertyData.type !== 'Commercial' &&
            <ul>
              { propertyData?.bedrooms > 0 && <li><Bed color={`#FFFFFF`} /> {propertyData?.bedrooms}</li> }
              { propertyData?.bathrooms > 0 && <li><Bath color={`#FFFFFF`} /> {propertyData?.bathrooms}</li> }
              { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
            </ul>
          }
          { propertyData.type === 'Commercial' &&
            <ul>
              { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
              { propertyLand?.buildingArea_value && <li className='area'><Build color={`#FFFFFF`} /> {propertyLand.buildingArea_value}㎡</li> }
              { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}㎡</li> }
            </ul>
          }
        </div>
      </div>
    )
  }
}

export default PropertyFeature
